<div *ngIf="data.length > 0">
    <h5 class="d-block text-blue text-center mt-4 mt-md-0 mb-3 mb-md-4">
        {{ 'rate.chart.distribution' | translate }}
    </h5>

    <svg height="160" width="160" viewBox="0 0 160 160" class="donut-chart">
        <g *ngFor="let d of data; let idx = index">
            <circle
                [attr.cx]="CX"
                [attr.cy]="CY"
                [attr.r]="RADIUS"
                [attr.stroke]="COLORS[idx]"
                [attr.stroke-width]="STROKE_WIDTH"
                [attr.stroke-dasharray]="adjustedCircumference"
                [attr.stroke-dashoffset]="calculateStrokeDashOffset(d.value, circumference)"
                [attr.fill]="'transparent'"
                [attr.transform]="circleTransformValue(idx)"
            />
        </g>
    </svg>

    <table class="table participants mt-3 mt-md-4">
        <thead>
            <tr>
                <th></th>
                <th>{{ 'rate.chart.name' | translate }}</th>
                <th>{{ 'rate.chart.percent' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-d [ngForOf]="data" let-idx="index">
                <tr>
                    <td class="align-middle">
                        <span class="dot" [style.background-color]="COLORS[idx]"></span>
                    </td>
                    <td>{{ d.name }}</td>
                    <td>{{ d.weight * 100 | number: '1.2-2' }} %</td>
                </tr>
            </ng-template>
        </tbody>
    </table>
</div>
